import { render, staticRenderFns } from "./LoadDetails.vue?vue&type=template&id=4f844409&scoped=true&"
import script from "./LoadDetails.vue?vue&type=script&lang=js&"
export * from "./LoadDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoadDetails.vue?vue&type=style&index=0&id=4f844409&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f844409",
  null
  
)

export default component.exports